/* Soulskart — SK system behaviour.
   Reveal on scroll, headline word rotator, channel switching.

   Quick add was removed from the storefront on request. The handlers that
   bound [data-sk-add] and posted to /cart/add.js are gone, along with the
   button in sections/sk-rail.liquid that carried it and the .sk-card__add
   rules in sk.css. That button passed
   product.selected_or_first_available_variant.id, so it added a size nobody
   chose — which is what prompted the removal. */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------- reveal --- */
  function watch(root) {
    var els = (root || document).querySelectorAll('.sk-rise:not(.sk-in-view)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) els[i].classList.add('sk-in-view');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('sk-in-view'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });
    for (var j = 0; j < els.length; j++) io.observe(els[j]);
  }

  /* --------------------------------------------------------- rotator --- */
  /* One word at a time, out the top, in from the bottom. Pauses when the
     tab is hidden and when the section scrolls out of view. */
  function rotators(root) {
    var nodes = (root || document).querySelectorAll('[data-sk-rot]:not([data-sk-bound])');
    for (var i = 0; i < nodes.length; i++) bindRotator(nodes[i]);
  }

  function bindRotator(el) {
    el.setAttribute('data-sk-bound', '1');
    var words = el.querySelectorAll('.sk-rot__w');
    if (words.length < 2) return;
    if (reduce) { words[0].classList.add('is-on'); return; }

    var i = 0, timer = null, visible = true;
    words[0].classList.add('is-on');

    function step() {
      var cur = words[i];
      i = (i + 1) % words.length;
      var next = words[i];
      cur.classList.remove('is-on');
      cur.classList.add('is-out');
      next.classList.add('is-on');
      setTimeout(function () { cur.classList.remove('is-out'); }, 700);
    }

    function start() {
      if (timer) return;
      var ms = Math.max(1200, parseInt(el.getAttribute('data-sk-rot'), 10) || 2400);
      timer = setInterval(function () { if (visible && !document.hidden) step(); }, ms);
    }
    function stop() { clearInterval(timer); timer = null; }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        visible = es[0].isIntersecting;
        if (visible) start(); else stop();
      }, { threshold: 0 }).observe(el);
    } else {
      start();
    }
  }

  /* -------------------------------------------------------- channels --- */
  function channels(root) {
    var nodes = (root || document).querySelectorAll('[data-sk-channels]:not([data-sk-bound])');
    for (var i = 0; i < nodes.length; i++) bindChannels(nodes[i]);
  }

  function bindChannels(scope) {
    scope.setAttribute('data-sk-bound', '1');
    var chips = scope.querySelectorAll('[data-sk-chip]');
    if (!chips.length) return;

    function select(key) {
      for (var i = 0; i < chips.length; i++) {
        chips[i].setAttribute('aria-pressed', chips[i].getAttribute('data-sk-chip') === key ? 'true' : 'false');
      }
      var panes = scope.querySelectorAll('[data-sk-pane]');
      for (var j = 0; j < panes.length; j++) {
        panes[j].hidden = panes[j].getAttribute('data-sk-pane') !== key;
      }
      watch(scope);
    }

    for (var k = 0; k < chips.length; k++) {
      chips[k].addEventListener('click', function () { select(this.getAttribute('data-sk-chip')); });
    }
    var first = scope.querySelector('[data-sk-chip][aria-pressed="true"]') || chips[0];
    select(first.getAttribute('data-sk-chip'));
  }

  /* Signals to the watchdog in layout/theme.liquid that this file is alive.
     If this never runs, that script removes html.sk-js after 2.5s and every
     .sk-rise element falls back to plain visible. */
  function boot(root) {
    document.documentElement.classList.add('sk-ready');
    watch(root);
    rotators(root);
    channels(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });
})();